import { inlcudePolyfills } from '@/helpers/polyfill';

inlcudePolyfills();

console.log(`Start ${process.env.APP_NAME}: (
  v.: '${process.env.VERSION_CONTROL}',
  node env.: '${process.env.NODE_ENV}',
  app. env.: '${process.env.REACT_APP_TARGET}'
)`);
